// extracted by mini-css-extract-plugin
export var container = "_4f-1";
export var cornerButtonContainer = "_4f-5";
export var disabled = "_4f-2";
export var fileContainer = "_4f-4";
export var hiddenInput = "_4f-3";
export var widthContainer = "_4f-0";